import styled, { BorderRadius, Color, Spacing } from '@nfinite/react-hubstairs/styled'
import { motion } from 'framer-motion'
import IconComponent from 'components/Commons/Icon'

const CROSS_ICON_SIZE = 15

const Overlay = styled(motion.div)`
  position: fixed;
  z-index: 9990;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
`

const Container = styled(motion.div)`
  background-color: ${Color.get('background')};
`

export const Bottom = {}

Bottom.Overlay = styled(Overlay)`
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
`

Bottom.Container = styled(Container)`
  position: relative;
  ${BorderRadius.generate({ top: 'xs', bottom: '0' })}
  width: 100vw;
  max-height: 90vh;
  min-height: 30vh;
  ${Spacing.generatePadding({ top: 'xl' })}
  overflow-y: auto;
`

Bottom.CloseBar = styled('div')`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:after {
    content: '';
    height: 2px;
    width: 80px;
    background-color: ${Color.get('text')};
  }
`

export const Left = {}

Left.Overlay = styled(Overlay)`
  align-items: flex-start;
  justify-content: flex-start;
  /* we need it because in mobile sometimes the page overflows the viewport. Which leads to wrong sized drawer 
  because by default it uses vw and vh. It will override the width and height defined in the Overlay
  */
  width: 100%;
  height: 100%;
`
Left.Container = styled(Container)`
  height: 100%;
  max-width: 90vw;
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.64);

  overflow-y: auto;
  ::-webkit-scrollbar {
    display: none;
  }
`
Left.CloseCross = styled('div')`
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  cursor: pointer;
  ${Spacing.generatePadding({ all: 's' })}
`
Left.CrossIcon = styled(IconComponent)`
  width: ${CROSS_ICON_SIZE}px;
  height: ${CROSS_ICON_SIZE}px;
`

export const Right = {}

Right.Overlay = styled(Overlay)`
  align-items: flex-start;
  justify-content: flex-end;
  /* we need it because in mobile sometimes the page overflows the viewport. Which leads to wrong sized drawer 
  because by default it uses vw and vh. It will override the width and height defined in the Overlay
  */
  width: 100%;
  height: 100%;
`
Right.Container = styled(Container)`
  height: 100%;
  width: fit-content;
  box-shadow: 0px 4px 80px 0px rgba(0, 0, 0, 0.1);
  overflow-y: auto;

  ::-webkit-scrollbar {
    display: none;
  }
`
Right.CloseCross = styled('div')`
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  cursor: pointer;
  ${Spacing.generatePadding({ all: 's' })}
`
Right.CrossIcon = styled(IconComponent)`
  width: ${CROSS_ICON_SIZE}px;
  height: ${CROSS_ICON_SIZE}px;
`
